import api from "../../../utilidades/interceptor";

const urlApi = process.env.REACT_APP_API_KEY;
const baseUrl = `${urlApi}/innovationDevelopment`;

const mostrarError = (contexto, error) => {
    console.error(`[PermisosSumaEquipos] Error en ${contexto}:`, error);
};

export const getUsersList = async () => {
    try {
        const { data } = await api.get(`${baseUrl}/users-list`);
        return data;
    } catch (error) {
        mostrarError('getUsersList', error);
        return [];
    }
};

export const getAppModules = async () => {
    try {
        const { data } = await api.get(`${baseUrl}/app-modules`);
        return data;
    } catch (error) {
        mostrarError('getAppModules', error);
        return [];
    }
};

export const getUserAppPermissions = async (userId) => {
    try {
        const { data } = await api.get(`${baseUrl}/user/${userId}/app-permissions`);
        return data;
    } catch (error) {
        mostrarError('getUserAppPermissions', error);
        return [];
    }
};

export const setUserAppPermissions = async (userId, modules) => {
    const { data } = await api.post(`${baseUrl}/user/${userId}/app-permissions`, { modules });
    return data;
};
